import Popup from './util/popup';

const $ = jQuery;

function getHeader() {
    return document.getElementsByClassName('lf-header')[0];
}

function getMenuToggle() {
    return document.getElementsByClassName('js-menu-toggle')[0];
}

function getMenu(toggle) {
    if (typeof toggle === 'undefined') toggle = getMenuToggle();
    return document.getElementById(toggle.getAttribute('aria-controls'));
}

function toggleMenu(value) {
    const toggle = getMenuToggle();
    const menu = getMenu(toggle);
    const header = getHeader();

    if (!toggle || !menu || !header) return;

    if (typeof value === "undefined") {
        value = !(toggle.getAttribute('aria-expanded') === 'true')
    }

    toggle.setAttribute('aria-expanded', value.toString());
    menu.setAttribute('aria-hidden', (!value).toString());

    if (value) Popup.lock(header, menu.querySelector('a'));
    else Popup.release(header);
}

const onWindowResize = (() => {
    let prevWidth = window.innerWidth;
    return () => {
        if (prevWidth >= 1440 && window.innerWidth < 1440) {
            toggleMenu(false);
        } else if (prevWidth < 1440 && window.innerWidth >= 1440) {
            getMenu().removeAttribute('aria-hidden');
        }
        prevWidth = window.innerWidth;
    }
})();

function attachCloseOnLinkClick() {
    $('.lf-navigation a').once('js-close-on-click').click(function (e) {
        toggleMenu(false);
    });
}

Drupal.behaviors.lfMenu = {
    attach: function (context, settings) {
        $('.js-menu-toggle', context).once('js-menu-toggle').on('click', () => toggleMenu());
        $(window).once('js-menu-resize').on('resize', onWindowResize);

        toggleMenu(false);
        if (window.innerWidth >= 1440) getMenu().removeAttribute('aria-hidden');

        // remove class that makes it hidden at the initial load
        getMenu().classList.remove('is-hidden-touch');

        attachCloseOnLinkClick();
    }
}
